<template>
  <svg
    width="31"
    height="28"
    viewBox="0 0 31 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.0057 1H21.1514C20.6446 1 20.2137 1.43083 20.2137 1.9377V3.93981H11.6984V1.9377C11.6984 1.43083 11.2676 1 10.7607 1H4.90645C4.39958 1 3.96875 1.43083 3.96875 1.9377V7.79197C3.96875 8.29884 4.39958 8.72967 4.90645 8.72967H10.7607C11.2676 8.72967 11.6984 8.29884 11.6984 7.79197V5.78986H20.2391V7.38648L10.3552 17.2703H4.90645C4.39958 17.2703 3.96875 17.7012 3.96875 18.208V24.0623C3.96875 24.5692 4.39958 25 4.90645 25H10.7607C11.2676 25 11.6984 24.5692 11.6984 24.0623V22.0602H23.7618L22.3426 23.4794C21.9878 23.8342 21.9878 24.4424 22.3426 24.7973C22.52 24.9747 22.7734 25.076 23.0015 25.076C23.2296 25.076 23.483 24.9747 23.6604 24.7973L26.6762 21.7814C27.0311 21.4266 27.0311 20.8184 26.6762 20.4636L23.6858 17.4731C23.3309 17.1183 22.7227 17.1183 22.3679 17.4731C22.0131 17.8279 22.0131 18.4361 22.3679 18.7909L23.7618 20.1848H11.6984V18.5882L21.5569 8.72967H27.0311C27.5379 8.72967 27.9688 8.29884 27.9688 7.79197V1.9377C27.9434 1.43083 27.5379 1 27.0057 1ZM9.82303 6.85428H5.8188V2.8754H9.79768V6.85428H9.82303ZM9.82303 23.1246H5.8188V19.1457H9.79768V23.1246H9.82303ZM26.0934 6.85428H22.0891V2.8754H26.0934V6.85428Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'StagesMenuIcon',
  props: {
    fill: {
      default: '#474B6D',
      type: String,
    },
  },
};
</script>